import InnerComponent from '@Components/Sales/Invoice/InvoiceForm';
import orgContainer from '@Components/AppContainer';

const UpdateInvoice = () => ((orgContainer(InnerComponent)));
export default UpdateInvoice;
